import { client } from '@core/api/API'

export default {
  /**
  * @param {{
  *  page?: number,
  *  limit?: number,
  *  effect?: string,
  *  floweringType?: string,
  *  name?: string,
  * }} params
  * @returns {Promise<object>}
  */
  async fetchStrains(params) {
    // const qs = new URLSearchParams({ page,  limit })
    // if (typeof effect === 'string' && effect.length > 0) {
    //   qs.set('effect', effect)
    // }

    // return client.get(`/strains?${qs.toString()}`).then(res => res.data.data)

    return await client.get('/strains', { params })
      .then(res => res.data)
  },

  /**
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  async fetchStrainProducers() {
    return await client.get('/strain-producers')
      .then(res => res.data)
  },

  async fetchStrainRetailers() {
    return await client.get('/strains/retailers')
      .then(res => res.data)
  },

  async fetchStrainEffects() {
    return await client.get('/strains/effects')
      .then(res => res.data)
  },

  async createCustomStrain(item) {
    return client.post('/strains/custom', item)
      .then(res => res.data)
  },

  async createCustomStrainProducer(item) {
    return client.post('/strain-producers/custom', item)
      .then(res => res.data)
  },
}
